// extracted by mini-css-extract-plugin
module.exports = {"navigationItem":"NavigationItem_navigationItem__3v7zr","active":"NavigationItem_active__1lSre"};